import AddonActionTypes from 'redux/addons/types';

const initialState = {
  addons: [],
  orgAddons: [],
  loading: false,
  error: null,
  saving: false,
};

function addonsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case AddonActionTypes.SET_ANY_DATA:
      return {
        ...state,
        ...payload,
      };

    case AddonActionTypes.START_FETCH_ALL_ADDONS:
      return {
        ...state,
        loading: true,
      };
    case AddonActionTypes.FETCH_ALL_ADDONS_SUCCESS:
      return {
        ...state,
        loading: false,
        addons: payload,
      };
    case AddonActionTypes.FETCH_ALL_ADDONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case AddonActionTypes.FETCH_ORG_ADDONS:
      return {
        ...state,
        loading: true,
      };
    case AddonActionTypes.FETCH_ORG_ADDONS_SUCCESS:
      return {
        ...state,
        loading: false,
        orgAddons: payload,
      };
    case AddonActionTypes.FETCH_ORG_ADDONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case AddonActionTypes.UPDATE_ADDON:
      return {
        ...state,
        saving: true,
      };
    case AddonActionTypes.UPDATE_ADDON_SUCCESS:
      return {
        ...state,
        saving: false
      };
    case AddonActionTypes.UPDATE_ADDON_FAILURE:
      return {
        ...state,
        saving: false,
        error: payload,
      };
    default:
      return state;
  }
}

export default addonsReducer;
